// components/Schooling.js
import React from "react";

const Schooling = () => {
  return (
    <section
      id="schooling"
      className="bg-gradient-to-r from-blue-400 shadow to-purple-600 w-full"
    >
      <h2 className="text-3xl font-bold mb-4 text-center ">Schooling</h2>

      <div className="max-w-xl bg-gradient-to-r from-blue-400 to-purple-600 p-8 mx-auto">
        <h3 className="text-2xl font-semibold">
          Bachelor of Engineering in Electronics and Communication Engineering
        </h3>
        <h4 className="text-lg font-medium">
          National Institute of Engineering, Mysore
        </h4>
        <p className="text-gray-600">August 2018 - September 2021</p>
        <p>Graduated with a CGPA of 7.5/10.</p>
        <ul className="list-disc list-inside mt-2">
          <li>Participated in coding competitions and hackathons.</li>
          <li>
            Member of the college's tech club, organizing workshops on emerging
            technologies.
          </li>
        </ul>

        <p></p>
        <p></p>
      </div>

      {/* You can add more educational experiences below */}
    </section>
  );
};

export default Schooling;
